"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exitActOnBehalfMode = exports.getActOnBehalfMode = void 0;
function getActOnBehalfMode() {
    const actOnBehalfOrganizationType = sessionStorage.getItem('organizationType');
    const actOnBehalfOrganizationId = sessionStorage.getItem('organizationId');
    const actOnBehalfModeFromOrigin = sessionStorage.getItem('fromOrigin');
    return { actOnBehalfOrganizationType, actOnBehalfOrganizationId, actOnBehalfModeFromOrigin };
}
exports.getActOnBehalfMode = getActOnBehalfMode;
function exitActOnBehalfMode() {
    sessionStorage.removeItem('organizationType');
    sessionStorage.removeItem('organizationId');
    sessionStorage.removeItem('fromOrigin');
}
exports.exitActOnBehalfMode = exitActOnBehalfMode;
//# sourceMappingURL=actOnBehalfMode.js.map